import { render, staticRenderFns } from "./fieldTelefone.vue?vue&type=template&id=321977fa&scoped=true"
import script from "./fieldTelefone.vue?vue&type=script&lang=js"
export * from "./fieldTelefone.vue?vue&type=script&lang=js"
import style0 from "./fieldTelefone.vue?vue&type=style&index=0&id=321977fa&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321977fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('321977fa')) {
      api.createRecord('321977fa', component.options)
    } else {
      api.reload('321977fa', component.options)
    }
    module.hot.accept("./fieldTelefone.vue?vue&type=template&id=321977fa&scoped=true", function () {
      api.rerender('321977fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/forms/fieldTelefone.vue"
export default component.exports